import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tooltip as MfTooltip } from '@famly/mf_data-display_tooltip';
const placementMap = {
    top: 'top',
    topLeft: 'top-start',
    topRight: 'top-end',
    bottom: 'bottom',
    bottomLeft: 'bottom-start',
    bottomRight: 'bottom-end',
    left: 'left',
    leftTop: 'left-start',
    leftBottom: 'left-end',
    right: 'right',
    rightTop: 'right-start',
    rightBottom: 'right-end',
};
/**
 * @deprecated use the Tooltip from `@famly/mf_data-display_tooltip` instead.
 *
 * Thin backwards-compatible wrapper around the MF Tooltip. Uses the `inverted`
 * variant to match the previous dark-background styling.
 */
const Tooltip = React.memo(({ overlay, children, placement, trigger, visible, overlayStyle, mouseEnterDelay, mouseLeaveDelay, }) => {
    const resolvedOverlay = typeof overlay === 'function' ? overlay() : overlay;
    const isDisabled = Array.isArray(trigger) && trigger.length === 0;
    const maxWidth = typeof (overlayStyle === null || overlayStyle === void 0 ? void 0 : overlayStyle.maxWidth) === 'number' ? overlayStyle.maxWidth : undefined;
    return (_jsx(MfTooltip, { variant: "inverted", tooltipContent: resolvedOverlay, placement: placement ? placementMap[placement] : undefined, isDisabled: isDisabled, open: visible, maxWidth: maxWidth, enterDelay: mouseEnterDelay, leaveDelay: mouseLeaveDelay, children: children }));
});
export default Tooltip;
